$('select[name="StudentId"]').change(function () {
    window.location = base_url + 'admin/reporting/studentevents/'  + $('ul.nav.flt_acyr li.active').text().trim() + '/'  + $('ul.nav.flt_wardteaching li.active').attr('data-ward').trim() + '/' + $(this).val();
});
